import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../Common/Logo';
import Icon from '../../Common/Icon';

const LandingFooter = React.memo(({ onPrivacyClick, onScienceClick, onTermsClick, onHelpClick, onResourcesClick, onKnowledgeGraphClick, onAboutClick, onDownloadsClick }) => (
  <footer className="landing-footer">
    <div className="landing-shell">
      <div className="landing-footer-content">
        <div className="landing-footer-brand-block">
          <div className="landing-footer-brand">
            <Logo size={24} />
            <span>ThryveLoop</span>
          </div>
          <p>Track what helps, keep your data private, and choose the next step with less noise.</p>
          <small>© 2026 ThryveLoop. Built for curious minds.</small>
        </div>

        <div className="landing-footer-links" aria-label="Footer links">
          <button type="button" onClick={onAboutClick}>About</button>
          <button type="button" onClick={onScienceClick}>Science</button>
          <button type="button" onClick={onResourcesClick}>Resources</button>
          <button type="button" onClick={onDownloadsClick}>Downloads</button>
          <button type="button" onClick={onPrivacyClick}>Privacy</button>
          <button type="button" onClick={onTermsClick}>Terms</button>
          <button type="button" onClick={onKnowledgeGraphClick}>Knowledge Graph</button>
          <button type="button" className="landing-footer-guide-button" onClick={onHelpClick}>
            <Icon name="message-circle" size={20} />
            <span>Help &amp; User Guidance</span>
          </button>
        </div>
      </div>
    </div>
  </footer>
));

LandingFooter.propTypes = {
  onPrivacyClick: PropTypes.func.isRequired,
  onScienceClick: PropTypes.func.isRequired,
  onTermsClick: PropTypes.func.isRequired,
  onHelpClick: PropTypes.func.isRequired,
  onResourcesClick: PropTypes.func.isRequired,
  onKnowledgeGraphClick: PropTypes.func.isRequired,
  onAboutClick: PropTypes.func.isRequired,
  onDownloadsClick: PropTypes.func.isRequired,
};

LandingFooter.displayName = 'LandingFooter';

export default LandingFooter;
